export enum keyCodes {
    TAB = 'TAB',
    ESC = 'Escape',
    ENTER = 'Enter',
    SPACE = 'SPACE',
}
